export const requestIframeResizeToFullHeight = ({ id }: { id: string }) => {
    window.parent.postMessage(
        {
            hbEvent: {
                type: 'hb_resize',
                id,
                height: document.body.scrollHeight
            }
        },
        '*'
    );
};

export const scrollToIframeTop = ({ id }: { id: string }) => {
    window.parent.postMessage(
        {
            hbEvent: {
                type: 'hb_scroll_to_top',
                id,
                height: document.body.scrollHeight
            }
        },
        '*'
    );
};

// Ultimately, this is the function that determines if the app is embedded in an iframe
export const isEmbeddedInIframe = () =>
    // In the lead forms embedding script, we call to /embed, which serves the exact same content as /public.
    // We utilize it here to determine if the client experience is embedded or not (edited)
    window.location.pathname?.split('/')[1] === 'embed';
